import React from "react";
import "./App.css";
import AquaponicsLanding from "./components/AquaponicsLanding";

function App() {
  return (
    <div className="App">
      <AquaponicsLanding />
    </div>
  );
}

export default App;